import { VIEW_AUDIT_LOGS } from '@/data/actions/modules/general';

export default [
  {
    path: '/audits',
    component: () => import(/* webpackChunkName: "audits" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: VIEW_AUDIT_LOGS,
    },
  },
];
